import { useAct } from 'FlowBuilder/store'
import AsyncSelect from 'Shared/components/AsyncSelect'

export default function DecisionMakersForm({ actionId }) {
  const act = useAct()
  const flowName = useSel(s => s.builder.flow.name)
  const action = useSel(s => s.actions.entities[s.local.selectedActionId])
  const config = action.config || { decisionMakerSetId: '', emailSenderId: '', customDecisionMakers: false }
  const decisionMakersSet = useSel(s => s.decisionMakersSet)
  const [usingExistingDecisionMakers, setUsingExistingDecisionMakers] = useState(decisionMakersSet?.id ? (decisionMakersSet?.oneOffSetForActionId ? false : true) : null)

  function update(data) {
    act.actions.upsert(actionId, { config: { ...config, ...data } })
  }

  function openFilterDecisionMakerSetModal() {
    act.local.setModal({ kind: 'filterDecisionMakerSet', actionId })
  }
  function openEditDecisionMakerSetModal() {
    act.local.setModal({ kind: 'editDecisionMakerSet', actionId })
  }
  const useNewDecisionMakers = () => {
    if (!decisionMakersSet.id || !decisionMakersSet.oneOffSetForActionId) {
      act.decisionMakersSet.initialiseNewDecisionMakersSet('Email Targets for ' + flowName, actionId)
    }
    setUsingExistingDecisionMakers(false)
    openEditDecisionMakerSetModal()
  }
  const useExistingDecisionMakers = () => {
    if (decisionMakersSet.oneOffSetForActionId) {
      update({ decisionMakerSetId: null })
    }
    setUsingExistingDecisionMakers(true)
  }

  useEffect(() => {
    if (config.decisionMakerSetId) {
      act.decisionMakersSet.loadDecisionMakersSet(config.decisionMakerSetId, action.id)
    }
  }, [config.decisionMakerSetId])

  //When we switch from a uuid to an id (i.e. a new set is saved, we update the config decision maker set id so it appears in the popup)
  const prevDecisionMakerSetId = useRef(null);
  useEffect(() => {
    if (prevDecisionMakerSetId.current && prevDecisionMakerSetId.current.length == 36 && decisionMakersSet.id && typeof decisionMakersSet.id === 'number') {
      update({ decisionMakerSetId: decisionMakersSet.id })
    }
    if (decisionMakersSet && decisionMakersSet.oneOffSetForActionId) {
      setUsingExistingDecisionMakers(false)
    } else if (decisionMakersSet && !decisionMakersSet.oneOffSetForActionId) {
      setUsingExistingDecisionMakers(true)
    }
    prevDecisionMakerSetId.current = decisionMakersSet?.id
  }, [decisionMakersSet?.id])


  return <div>
    <div className='input-group to'>
      <h2 className='no-margin-top'>Who's the action to?</h2>
      <div className='margin-bottom'>
        <label>
          <input
            type="radio"
            name="useExistingDecisionMakers"
            checked={usingExistingDecisionMakers === true}
            onChange={useExistingDecisionMakers}
          />
          Pick a list of recipients
        </label>
        {usingExistingDecisionMakers === true && <div className='box danger-zone margin-top margin-bottom'>
          <label className="bold margin-bottom">Select a list of recipients</label>
          <AsyncSelect
            entity="decision_maker_set"
            value={config.decisionMakerSetId}
            onChange={value => update({ decisionMakerSetId: value })}
            loadStaticList
          />
          {config.decisionMakerSetId &&
            <button className='button primary margin-top' onClick={openFilterDecisionMakerSetModal}>Enable/disable recipients</button>
          }
        </div>}
        <label className="margin-top half">
          <input
            type="radio"
            name="useExistingDecisionMakers"
            checked={usingExistingDecisionMakers === false}
            onChange={useNewDecisionMakers}
          />
          Enter a list of recipients for this action
        </label>
      </div>
      {usingExistingDecisionMakers === false && <div className='box danger-zone margin-top'>
        <p className='no-margin-top bold'>Recipients: {decisionMakersSet.name}</p>
        <p>{decisionMakersSet.decisionMakers?.length || 0} recipients</p>
        <button className='button primary' onClick={openEditDecisionMakerSetModal}>Edit recipients</button>
      </div>}
    </div>
  </div>
}
